import classnames from 'classnames'
import classNames from 'classnames'

import type { ArticleListItemProps } from '~/components/atoms/ArticleListItem/ArticleListItem'
import ArticleListItem from '~/components/atoms/ArticleListItem/ArticleListItem'
import Container from '~/components/atoms/Container/Container'
import DynamicSlider from '~/components/atoms/DynamicSlider'
import Fixture from '~/components/atoms/Fixture/Fixture'
import Link from '~/components/atoms/Link/Link'
import Text, { TextSizes } from '~/components/atoms/Text/Text'
import { ComponentTheme } from '~/components/themes'
import { multiPostHogEventPusher } from '~/utils/analyticsPusher'

import styles from './PressRelatedArticles.module.css'

export interface PressRelatedArticlesProps {
  articles: ArticleListItemProps[]
  title?: string | undefined | null
  category?: string
  verticalPadding?: boolean
  reducedHeight?: boolean
  categoryType?: string
}

export default function PressRelatedArticles({
  articles,
  title = 'As seen in',
  category,
  verticalPadding = true,
  reducedHeight = false,
  categoryType = 'category',
}: PressRelatedArticlesProps) {
  const baseThemeClass = ComponentTheme.primary

  return (
    <div
      className={classnames(
        styles.base,
        baseThemeClass && styles[baseThemeClass]
      )}
    >
      <Fixture verticalPadding={verticalPadding} noPaddingBottom>
        <div style={{ overflow: 'hidden' }}>
          <div className={styles.wrap}>
            <Container
              cssClass={classnames(
                styles.sliderContainer,
                reducedHeight && styles.sliderContainerReducedHeight
              )}
            >
              <div className={classNames(styles.slideHead)}>
                {title && (
                  <Text
                    size={TextSizes.primaryTitleLrg}
                    className={styles.slideHeadTitle}
                  >
                    {title}
                  </Text>
                )}

                <Link
                  href={`/press/all-articles${
                    category ? `?${categoryType}=${category}` : ''
                  }`}
                  onClick={async () => {
                    await multiPostHogEventPusher([
                      {
                        eventType: `Edition Magazine Browse clicked`,
                      },
                    ])
                  }}
                >
                  <Text
                    size={TextSizes.primaryTitleLrg}
                    className={styles.slideHeadBrowse}
                  >
                    View all
                  </Text>
                </Link>
              </div>

              <DynamicSlider
                slidesPerView={1.4}
                slidesPerViewMed={2.4}
                slidesPerViewLrg={3.4}
                overflowVisible={true}
                hideTitle={true}
                hideArrows={false}
                hideArrowsMobile={true}
                useScrollbar
                spacer={false}
                wrapperClass={styles.sliderWrapperClass}
              >
                {articles?.map((item: ArticleListItemProps, i: number) => {
                  return (
                    <ArticleListItem
                      showSummary={false}
                      marginBottom={true}
                      key={`press-related-article-${item.id}-${i}`}
                      {...item}
                    />
                  )
                })}
              </DynamicSlider>
            </Container>
          </div>
        </div>
      </Fixture>
    </div>
  )
}
